const loadingDotsTemplate = require('./../../../shared/templates/loading-dots-row-template.handlebars');
const previousEntriesModalTableTemplate = require('./previous-entries-modal-table.handlebars');
const crosswordPreviousEntriesModalTableTemplate = require('./crossword-previous-entries-modal-table.handlebars');
const EXTRACHANCE_GAME_LIST = require('./../EXTRACHANCE_GAMES_LIST').default;
const enterTicketsExtraChancesTemplate = require('./entertickets.extrachances.handlebars');
const enterTicketsExtremeMillionsTemplate = require('./entertickets.extrememillions.handlebars');
const enterTicketsSecondChanceBasicTemplate = require('./entertickets.secondchancebasic.handlebars');
const enterTicketsGasNGoTemplate = require('./entertickets.GasNGo.handlebars');
const enterTicketsMegaGroceryTemplate = require('./entertickets.MegaGrocery.handlebars');
const enterTicketsCrossWordTemplate = require('./entertickets.CrossWord.handlebars');
const enterTicketsLuxuryCruisinTemplate = require('./entertickets.luxurycruisin.handlebars');
const enterTicketsNyRockinEveTemplate = require('./entertickets.NyRockinEve.handlebars');
const enterTicketsFanCaveTemplate = require('./entertickets.FanCave.handlebars');
const enterTicketsDailyCashTemplate = require('./entertickets.dailycash.handlebars');
const enterTicketsCashwordCrosswordTemplate = require('./entertickets.cashwordcrossword.handlebars');
const enterTicketsNoSelectionTemplate = require('./entertickets.noselection.handlebars');
const enterTicketsCounter = require('./../enterticketscounter/enterticketscounter');
const Pager = require('./../../../shared/components/pager/pagerService');
const EnableAutoTab=require('../../../shared/scripts/EnableAutoTab');
var allPreviousEntriesModalService = new allPreviousEntriesModalService();
var allPreviousEntriesModalPager = new Pager();

$(function () {
    if (!$('.enter-tickets-container').length) return;

    //INIT
    let initialExtraChanceGameId = $('#initial-extra-chance-game-id').val();
    let initialExtraChancePromoId = $('#initial-extra-chance-promo-id').val();
    allPreviousEntriesModalPager.setPageSize(allPreviousEntriesModalService.options.pageSize)

    if (!initialExtraChanceGameId) {
        initializeScratcherSelector();
    } else {
        allPreviousEntriesModalService.options.gameId = initialExtraChanceGameId;
        let uniqueTicketEntryDisplay = EXTRACHANCE_GAME_LIST.find(item => item.id === parseInt(initialExtraChanceGameId));
        $('#scratcher-selector').addClass('hidden');
        createSpecificNumberInputDisplay(uniqueTicketEntryDisplay.id, uniqueTicketEntryDisplay);
    }

    if (!initialExtraChancePromoId) {
        //TODO: What happens when PromoID isnt set in hidden field?
    } else {
        allPreviousEntriesModalService.options.promoId = initialExtraChancePromoId;
    }

    //EVENTS
    $('#btn-submit-ticket').on('click', function () {
		ng_fw.keepAlive();
        btnSubmitTicketsClick(initialExtraChanceGameId);
    });

    $("#scratcher-selector .dropdown-menu li").on('click', function () {
        setDropdownSelection(this, 'scratcher-id');
        updateNumberInputDisplay(this);
    });

    $('#enterTickets-allPreviousEntries-modal').on('show.bs.modal', function () {
        allPreviousEntriesModalPager.setCurrentPage(0);
        getPreviousEntries();
    });
});

function initializeScratcherSelector() {
	console.log('initializeScratcherSelector called')
    const $scratcherDropdownMenu = $('#scratcher-selector .dropdown-menu');
    let $selectedOption = $scratcherDropdownMenu.children().first();

    updateNumberInputDisplay($selectedOption);
    setDropdownSelection($selectedOption, 'scratcher-id');
}

function setDropdownSelection(selectedItem, dataName) {
    const $selectedItem = $(selectedItem);
    const $dropdown = $selectedItem.parents('.dropdown');

    $dropdown.find('.btn .dropdown-display').html($selectedItem.text());
    $dropdown.find('.btn').val($selectedItem.data(dataName));
}

function updateNumberInputDisplay(selectedItem) {
    const selectedScratcherId = $(selectedItem).data('scratcher-id');
    let uniqueTicketEntryDisplay = EXTRACHANCE_GAME_LIST.find(item => item.id === 0);
    let html = buildTicketInputHtml(selectedScratcherId, uniqueTicketEntryDisplay);

    $('.enter-tickets-container .ticket-input-container').html(html);
    initializeValidation();
    setInputFocus();
	InputAutoTab();
};

function createSpecificNumberInputDisplay(extraChancesGameId, extraChancesGame) {
    let html = buildTicketInputHtml(extraChancesGameId, extraChancesGame);

    $('.enter-tickets-container .ticket-input-container').html(html);
    initializeValidation();
    setInputFocus();
	InputAutoTab();
};
/*---To enable Auto Tab : Added on 08/01/2019---*/
function InputAutoTab(){     
    $('.numeric-only').on('keyup',function(e) {
        EnableAutoTab($(this),1);
    });
}

function buildTicketInputHtml(gameId, ticketEntry) {
    let templateData = {
        scratcherId: gameId,
        inputsToCreate: ticketEntry.inputsToCreate,
        webCode: ticketEntry.webCode
    };

    switch (ticketEntry.id) {
        case 1841:
            return enterTicketsExtremeMillionsTemplate(templateData)
            break;
			 case 1932:
            return enterTicketsSecondChanceBasicTemplate(templateData)
            break;
			case 156://this needs to be change as per game type 
            return enterTicketsGasNGoTemplate(templateData)
            break;
			case 149://this needs to be change as per game type 
            return enterTicketsMegaGroceryTemplate(templateData)
            break;
			case 2036:// Super Bonus CrossWord  
            return enterTicketsCrossWordTemplate(templateData)
            break;
			case 1952: // Luxury Cruisin
			return enterTicketsLuxuryCruisinTemplate(templateData)
			break;
			case 152: // NY RockingEve
			return enterTicketsNyRockinEveTemplate(templateData)
			break;
			case 153: // FanCave
			return enterTicketsFanCaveTemplate(templateData)
			break;
			
        // case 88888:
        //     return enterTicketsDailyCashTemplate(templateData)
        //     break;
        // case 99999:
        //     return enterTicketsCashwordCrosswordTemplate(templateData)
        //     break;
        default:
            return enterTicketsExtraChancesTemplate(templateData);
            break;
    }
};

function initializeValidation() {
    $(".enter-tickets-container .number-input input.numeric-only").on('keypress', function(event) {
		var key=window.event ? event.keyCode : event.which;
	   if ((key==8 || key==9 || key==46)||(key >=48 && key <= 57))
            return true;  
        return false;		   
	});
	//=> /\d/.test(String.fromCharCode(e.keyCode)));
}
function setInputFocus() {
    const firstInput = $('.enter-tickets-container .ticket-input-container .number-input').first().find('input');
    firstInput.focus();
}

function btnSubmitTicketsClick(gameId) {
    let data = getUserEnteredValues(gameId);
	console.log(data);
    let url='/api/v1/'+(gameId=='153'?'fancavesubmitticket':gameId=='152'?'submit':gameId=='1952'?'luxurycruisinsubmit':gameId=='2036'?'crosswordsubmit':gameId=='156'?'gasngosubmit':gameId=='149'?'megagrocerysubmit':gameId=='1841'?'extrememillionssubmit':'ultimatevegasgetawaysubmit');  
    $.ajax({
        url: url,
        type: 'POST',
        data: data,
        dataType: 'json'
    })
        .done(function (data) {
            if (!data.isValid) {
                showValidationModal(data.message);
            } else {
                showConfirmationModal();
                clearUserEnteredValues();
				//---To enable crossword claim prize container
				if(gameId=='2036'){					
					var playgameURL=$('#prize-claim-playgame-link').attr("href")+data.developerMessage;
					$('#prize-claim-playgame-link').attr("href",playgameURL);
					$('#ticket-submit-container').addClass('hide');
					$('#prize-claim-container').removeClass('hide').addClass('show');
				}
                enterTicketsCounter.getEntriesCountForGame(gameId);
            }
        });

}
function getUserEnteredValues(gameId) {
    let numberInputs = $('[id=ticket-inputs]').children('.number-input');
    let numbers = [];

    $.each(numberInputs, function (index, value) {
        numbers.push($(value).children('input').val());
    });
	if(gameId=='152' || gameId=='153' || gameId=='149' || gameId=='156')
	{
		return {        
			ticketNumber2: numbers[1],
			ticketNumber3: numbers[2],
			ticketNumber4: numbers[3],
			webCode: numbers[0]
		}
	}
	else{
		return {
			gameId: numbers[0],
			ticketNumber2: numbers[1],
			ticketNumber3: numbers[2],
			ticketNumber4: numbers[3],
			webCode: numbers[4]
		}
	}
}

function clearUserEnteredValues() {
    let numberInputs = $('[id=ticket-inputs]').children('.number-input');

    $.each(numberInputs, function (index, value) {
        var isReadOnlyGameId = $(value).is('#enterticket-readonly-gameid');
        if (isReadOnlyGameId)
            return;

        $(value).children('input').val("");
    });
}

function showConfirmationModal() {
    $('#enterTickets-confirmation-modal').modal('show');
}

function showValidationModal(validationMessage) {
    let $modalValidationMessage = $('#enterTickets-validation-modal-message');

    if (!validationMessage) {
        $modalValidationMessage.text("Something unexpected happened. Please try again.");
    } else {
        $modalValidationMessage.text(validationMessage);
    }

    $('#enterTickets-validation-modal').modal('show');
}

function getPreviousEntries() {

    showIsLoadingIcon("#enterTickets-allPreviousEntries-container");

    allPreviousEntriesModalService.options.gameroomId = sessionStorage.getItem('GameroomID');
    allPreviousEntriesModalService.options.pageSize = allPreviousEntriesModalPager.getPageSize();
    allPreviousEntriesModalService.options.page = allPreviousEntriesModalPager.getCurrentPage();
    let gameId = $('#initial-extra-chance-game-id').val();
    let url='/api/v1/'+(gameId=='153'?'fancavegetentries':gameId=='152'?'getentries':gameId=='1952'?'getluxurycruisinentries':gameId=='2036'?'getcrosswordentries':gameId=='156'?'getgasngoentries':gameId=='149'?'getmegagroceryentries':'getultimatevegasgetawayentries');
    $.ajax({
        url: url,
        type: 'POST',
        data: allPreviousEntriesModalService.options,
        dataType: 'json'
    })
        .done(function (data) {
			var previousEntryData = {
                results: null,
                message: null
            };
			var html=null;
			try{
            if (!data) {
                previousEntryData.message = "An unexpected error has occurred. Please try again.";
            } else if (!data.Results) {
                previousEntryData.message = "No previous entries found.";
            } else {
				
				if(gameId=='2036')
				{
					previousEntryData.results = data.Results.map((v, i, a) => {
                    let d = new Date(v.EntryDate);
                    let entryDateFormatted = `${(d.getMonth() + 1)}/${d.getDate()}/${d.getFullYear()}`;
                    let d1 = new Date(v.Played);
                    let PlayedDateFormatted = `${(d1.getMonth() + 1)}/${d1.getDate()}/${d1.getFullYear()}`;
                    return {                        
                        ticketNumber: v.TicketNumber,
						entryDateFormatted: entryDateFormatted,
						PlayedDateFormatted:PlayedDateFormatted,
						PrizeAwarded:v.PrizeAwarded
                    };
                });
				//html = crosswordPreviousEntriesModalTableTemplate({ previousEntries: previousEntryData });
				}
				else{
					previousEntryData.results = data.Results.map((v, i, a) => {
                    let d = new Date(v.EntryDate);
                    let entryDateFormatted = `${(d.getMonth() + 1)}/${d.getDate()}/${d.getFullYear()}`;
                    let d1 = new Date(v.DrawDate);
                    let drawDateFormatted = `${(d1.getMonth() + 1)}/${d1.getDate()}/${d1.getFullYear()}`;
                    return {
                        entryDateFormatted: entryDateFormatted,
                        entryNumber: v.EntryNumber,
                        gameDescription: v.GameDescription,
                        ticketNumber: v.TicketNumber,
						drawDateFormatted:drawDateFormatted
                    };
                });
				//html = previousEntriesModalTableTemplate({ previousEntries: previousEntryData });
				}
			}
			}
			catch(error){console.log(error.message);}
				
			html = (gameId=='2036'?crosswordPreviousEntriesModalTableTemplate({ previousEntries: previousEntryData }):previousEntriesModalTableTemplate({ previousEntries: previousEntryData }));
            
            $('#enterTickets-allPreviousEntries-container').html(html);

            allPreviousEntriesModalPager.update("allPreviousEntriesModal-pager", "#allPreviousEntries-pager-container", getPreviousEntries, data.TotalPages, data.Page);
			
			});	 
}

function showIsLoadingIcon(containerSelector) {
    var html = loadingDotsTemplate();
    $(containerSelector).html(html);
}

function allPreviousEntriesModalService(options) {
    var allPreviousEntriesModalDefaultOptions = {
        page: 0,
        totalPages: 0,
        pageSize: 12,
        gameroomId: null, //GameroomID from sessionStorage
        promoId: null
    };

    this.options = $.extend(true, allPreviousEntriesModalDefaultOptions, options);
}


// WEBPACK FOOTER //
// ./features/extrachances/entertickets/entertickets.js